import { api_host } from "../../common/globals/constants";
import { getObjectivesIgnoreCache } from "../getObjectives";
import queryString from "query-string";

function getApiKeys() {
    const token = sessionStorage.getItem("key");
    const user = sessionStorage.getItem("user");

    return { token, user };
}

export function createTag(tag) {
    const { token } = getApiKeys();
    return fetch(`${api_host}/reporte/general/etiquetas/?token=${token}`, {
        method: "POST",
        body: JSON.stringify({ token, ...tag }),
        headers: {
            "Content-Type": "application/json",
        },
    });
}

export function updateTag(tag) {
    const { token } = getApiKeys();
    return fetch(`${api_host}/reporte/general/etiquetas/?token=${token}`, {
        method: "PATCH",
        body: JSON.stringify({ token, ...tag }),
        headers: {
            "Content-Type": "application/json",
        },
    });
}

export function getListadoEtiquetas() {
    const start = Date.now();
    const { token, user } = getApiKeys();
    const queryParamsParsed = queryString.parse(document.location.search);
    const isPublic = document.location.pathname === "/public/flashboard";
    const urlToken = queryParamsParsed["token"];
    const publicUrl = `${api_host}/public/flashboard/etiquetas/?token=${urlToken}`;
    const withAuthUrl = `${api_host}/reporte/general/etiquetas/?token=${token}&user=${user}&start=${start}`;
    return fetch(isPublic ? publicUrl : withAuthUrl).then((response) =>
        response.json()
    );
}

export function deleteTag(tag) {
    const { token, user } = getApiKeys();
    return fetch(
        `${api_host}/reporte/general/etiquetas/?token=${token}&user=${user}`,
        {
            method: "DELETE",
            body: JSON.stringify({ token, ...tag }),
            headers: {
                "Content-Type": "application/json",
            },
        }
    );
}

export function updateEtiquetasObjetivo({ objetivoId, etiquetas }) {
    const { token } = getApiKeys();
    return fetch(
        `${api_host}/reporte/general/objetivos/${objetivoId}/etiqueta_objetivo/?token=${token}`,
        {
            method: "PATCH",
            body: JSON.stringify({ token, etiquetas }),
            headers: {
                "Content-Type": "application/json",
            },
        }
    );
}

export function updateObjetivos() {
    const { token, user } = getApiKeys();
    return getObjectivesIgnoreCache(user, token).then((data) => {
        let dataSeries = [];
        let dataServices = [];
        let checked = [];

        dataServices.push("Todos");
        checked.push(0);
        Object.keys(data).forEach((keyType) => {
            if (keyType !== "Services" && keyType !== "ServicesUnified") {
                let serie = data[keyType];
                Object.keys(serie).forEach((key) => {
                    serie[key].nombre = serie[key].nombre.replaceAll("/", "|");
                    dataSeries.unshift(serie[key]);
                });
            } else if (keyType === "ServicesUnified") {
                let serie = data[keyType];
                Object.keys(serie).forEach((key) => {
                    checked.push(parseInt(key) + 1);
                    dataServices.push(serie[key]);
                });
            }
        });
        localStorage.setItem("isLoadObjectiveList", true);
        dataSeries.sort(function (a, b) {
            var priorityA = a.orden || Infinity;
            var priorityB = b.orden || Infinity;

            if (priorityA < priorityB) return -1;
            if (priorityA > priorityB) return 1;

            if (a.nombre < b.nombre) return -1;
            if (a.nombre > b.nombre) return 1;
            return 0;
        });
        sessionStorage.setItem("listaData", JSON.stringify(data));
        sessionStorage.setItem(
            "listaObjetivosOnline",
            JSON.stringify(dataSeries)
        );
        sessionStorage.setItem("dataServices", JSON.stringify(dataServices));
        sessionStorage.setItem("checked", JSON.stringify(checked));
        sessionStorage.setItem("listsLoads", true);

        return data;
    });
}
